import React from 'react';
import { LockIcon } from 'lucide-react';
type SecurePaymentBadgeProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
export function SecurePaymentBadge({
  tone = 'light',
  className = ''
}: SecurePaymentBadgeProps) {
  const styles = tone === 'light' ? 'border-sand text-warmgray' : 'border-sand/25 text-sand/80';
  return <p className={`inline-flex items-center gap-2.5 rounded-full border px-4 py-2 font-sans text-[0.6rem] uppercase tracking-[0.18em] ${styles} ${className}`} data-id="element-214" data-mp="3q5nwp4bd7rop">
      <LockIcon className="h-3 w-3 text-gold" aria-hidden="true" data-id="element-215" data-mp="mo5txbag9av5" />
      Pago 100% seguro
    </p>;
}